let prefix = '/api/sap/sub-items';
function subItems(){
    return window.axios.get(prefix);
}

export default {
    subItems,
}